import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import { useIsMobile } from '../ProjectLocation/helpers';

function DeleteStairModal(props) {

  const {
    title,
    bodyText,
    onDismiss,
    onConfirmation,
    showDeleteModal,
    numbreOfSteps,
  } = props;

  const isMobile = useIsMobile();

  return (
    <>
      <Modal size="sm" open={showDeleteModal} onClose={onDismiss} id={title}>
        <ModalHeader onClose={onDismiss}>
          <Typography variant="h4" weight="bold" style={{ marginBottom: '1.6rem' }}> {title} </Typography>
        </ModalHeader>
        <ModalBody>
          <Typography>
            <span>{bodyText}</span>
            <span style={{ fontWeight: 'bold' }}> {numbreOfSteps}</span>
            <span> steps?</span>
          </Typography>
        </ModalBody>
        <ModalFooter position="end">
          <ButtonGroup
            orientation={isMobile ? 'vertical' : 'horizontal'}
            variant={isMobile ? 'primary' : 'secondary'}
          >
            <Button variant="secondary" style={{ display: isMobile && 'none' }} onClick={onDismiss}>Cancel
            </Button>
            <Button variant="primary" onClick={onConfirmation}>Delete Stairs</Button>
            <Button variant="secondary" style={{ display: !isMobile && 'none' }} onClick={onDismiss}>Cancel
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </Modal>
    </>
  );
}

DeleteStairModal.propTypes = {
  title: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
  numbreOfSteps: PropTypes.number.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onConfirmation: PropTypes.func.isRequired,
  showDeleteModal: PropTypes.bool,
};

DeleteStairModal.defaultProps = {
  showDeleteModal: false,
};

export default DeleteStairModal;